// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OhRc","right":"styles_right__CA-wN"};